export default "__VITE_ASSET___7JVG9gI__"